import * as React from 'react';

import { requestPut } from '../../../../../modules/request/index';
import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility';
import DemoGuardedButton from '../../shared/demoGuardedButton';

const ArchiveModal = ({ onSuccess, closeModal, unitId, unitName, notice = null, additionalUnitIds = [], onFailure = null, }) => {
  const { modalRef } = useModalAccessibility(closeModal);

  function handleArchiveUnitButtonClick() {
    const unitIds = [unitId, ...additionalUnitIds]
    let remaining = unitIds.length
    let anyFailed = false
    const settle = (failed: boolean) => {
      anyFailed = anyFailed || failed
      remaining -= 1
      if (remaining > 0) { return }
      anyFailed ? onFailure() : onSuccess('Activity pack deleted')
    }
    unitIds.forEach(id => {
      const request = requestPut(`/teachers/units/${id}/hide`, {}, () => settle(false), onFailure ? () => settle(true) : undefined)
      if (onFailure) { request?.catch?.(() => settle(true)) }
    })
  }

  return (
    <div className="modal-container archive-activity-pack-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="archiveActivityPackModalTitle"
        aria-modal="true"
        className="archive-activity-pack-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="archiveActivityPackModalTitle">Permanently delete this activity pack?</h3>
        </div>
        <div className="archive-activity-pack-modal-text">
          {notice}
          <p>Deleting an activity pack is permanent and cannot be undone. You will no longer have access to it in your student reports.</p>
          <p>If you no longer want students to see an activity pack and wish to retain access to it in your student reports, we suggest using the “Close activity pack” option instead.</p>
        </div>
        <div className="form-buttons">
          <button className="quill-button outlined medium grey focus-on-light" onClick={closeModal} type="button">Cancel</button>
          <DemoGuardedButton className="quill-button contained medium green focus-on-light" onClick={handleArchiveUnitButtonClick}>Delete</DemoGuardedButton>
        </div>
      </div>
    </div>
  )
}

export default ArchiveModal
